import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import moment from "moment";

import CloseIcon from "assets/icons/close.svg?react";
import SecondCheckbox from "components/SecondCheckbox";
import { ICertificate } from "dto/ICertificate";
import { useAuth } from "react-oidc-context";
import { getUserId } from "utils/getUserId";
import { Tooltip } from "@mui/material";
import RemoveIcon from "assets/icons/bin.svg?react";
import { useTranslation } from "react-i18next";

const ChooseSigningCertificate: FC<Props> = ({
  onClick,
  toggle,
  certs,
  allowChooseMethod,
}) => {
  const { t } = useTranslation();
  const [IsXades, setIsXades] = useState(false);

  const [visibleCerts, setVisibleCerts] = useState<ICertificate[]>([]);

  const auth = useAuth();
  const userId = getUserId(auth.user!);
  const hiddenCertsData = useMemo(
    () => localStorage.getItem(`${userId}.hiddenCerts`),
    []
  );
  const hiddenCerts = useMemo(
    () => JSON.parse(hiddenCertsData ?? "[]") as string[],
    [hiddenCertsData]
  );

  useEffect(() => {
    setVisibleCerts(
      certs.filter((x) => hiddenCerts.indexOf(x.SerialNumber) === -1)
    );
  }, [certs, hiddenCerts]);

  const handleRemove = (c: ICertificate) => {
    const hiddenCertsData = localStorage.getItem(`${userId}.hiddenCerts`);
    const hiddenCerts = JSON.parse(hiddenCertsData ?? "[]") as string[];

    const newHiddenCerts = [...hiddenCerts, c.SerialNumber];

    localStorage.setItem(
      `${userId}.hiddenCerts`,
      JSON.stringify(newHiddenCerts)
    );
    setVisibleCerts(
      certs.filter((x) => newHiddenCerts.indexOf(x.SerialNumber) === -1)
    );
  };

  return ReactDOM.createPortal(
    <div className={styles.modalWrapper}>
      <div className={styles.modal}>
        <div className={styles.Modaltitle}>
          Wybierz certyfikat
          <CloseIcon onClick={toggle} />
        </div>
        {allowChooseMethod && (
          <div className={styles.choose}>
            <SecondCheckbox
              value={!IsXades}
              onChange={() => setIsXades(false)}
              text="Pades"
            />
            <SecondCheckbox
              value={IsXades}
              onChange={() => setIsXades(true)}
              text="Xades"
            />
          </div>
        )}
        <div className={styles.list}>
          {visibleCerts.map((cert: ICertificate) => (
            <div
              onClick={() => onClick(cert)}
              className={styles.box}
              key={cert.SerialNumber}
            >
              <div className={styles.title}>
                <div className={styles.name}>{cert.Name}</div>
                <div className={styles.date}>
                  {moment(cert.ValidTo).format("DD.MM.YYYY").toString()}
                </div>
              </div>
              <div className={styles.cert}>{cert.IssuerBy}</div>

              {cert.Priority === 0 && (
                <div className={styles.menu}>
                  <Tooltip title={t("common.remove")}>
                    <div>
                      <RemoveIcon
                        className={styles.ic}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleRemove(cert);
                        }}
                      />
                    </div>
                  </Tooltip>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ChooseSigningCertificate;
